import './banner-inner.module.scss';
import slide from '../../assets/images/slider-one.jpg';
import { Component } from 'react';
/* eslint-disable-next-line */
export interface BannerInnerProps {
  bannerImage?: string;
  caption?: string;
  link?: string;
  linktext?: string;
}

class BannerInner extends Component<BannerInnerProps> {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { link, linktext, caption, bannerImage } = this.props;
    return (
      <section id="hero">
        <div className="hero-banner banner-inner">
          <div className="hr-slide">
            <div className="slide-img">
              {bannerImage && <img src={bannerImage} alt="slide" />}
            </div>
            <div className="caption">
              <div className="container-small">
                {caption}
                <a
                  href={link ? link : '/contact-us'}
                  className="btn-theme btn-md"
                >
                  {linktext ? linktext : 'Get Started'}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default BannerInner;
